export default __webpack_public_path__ + "static/media/survey.03574545.svg";